import { connect } from 'react-redux';
import { mapDispatchToFindClubs, mapStateToFindClubs } from '../mapToProps';
import FindClubsView from '../views/findClubsView';

export const FindClubsPresenter = connect(
    mapStateToFindClubs, 
    mapDispatchToFindClubs
)(FindClubsView);